module.exports = __webpack_public_path__ + "static/media/bg-navbar.cbdd4783.png";